import { Dispatch, SetStateAction } from "react";

/** --- PinnacleDialog Helpers --- */
export const handleDialogClose = (
  reason: string,
  setIsOpen: Dispatch<SetStateAction<boolean>>,
  disableBackDropClick: boolean,
) => {
  if (reason === 'backdropClick') {
    setIsOpen(false);
  }
};
